import React, { useState, useEffect } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,
    TableCell,
    Select,
} from "@material-ui/core";
import EventService from "./Locality/Service/eventService";
import ParkService from "./Locality/Service/parkService";
import * as Yup from 'yup';
import { Typography } from "../../components/Wrappers/Wrappers";
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(255, 107, 129)",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    tableOverflow: {
        overflowX: 'auto',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

export default function Event() {
    const tableHeaders = [ 'Event Name', 'From Date', 'To Date', 'From Time', 'To Time', 'Status', 'Edit', 'Delete'];
    const classes = useStyles();
    const [eventList, setEventList] = useState([]);
    const [parkList, setParkList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const [event, setEvent] = useState({
        eventName: '',
        description: '',
        fromDate: '',
        toDate: '',
        fromTime: '',
        toTime: '',
        status: true,
    });

    const validationSchema = Yup.object().shape({
        eventName: Yup.string().required('Event Name is required'),
        description: Yup.string(),
        fromDate: Yup.date().required('From Date is required'),
        toDate: Yup.date().required('To Date is required').min(Yup.ref('fromDate'), 'To Date must be after From Date'),
        fromTime: Yup.string(),
        toTime: Yup.string(),
    });

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    };

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    };

    useEffect(() => {
        getEventList();
        getParkList();
        return () => {
            setEventList([]);
            setParkList([]);
        };
    }, []);

    const getParkList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const profileId = userDetails.role === "admin" ? null : userDetails.profileId;
        
        ParkService.getParks({ profileRegistrationId: profileId }).then((res) => {
            setParkList(res);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getEventList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const profileId = userDetails.role === "admin" ? null : userDetails.profileId;
        
        EventService.getEvent({ profileRegistrationId: profileId }).then((res) => {
            setEventList(res);
        }).catch((err) => {
            console.error(err);
        });
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setEvent({
            eventName: '',
            description: '',
            fromDate: '',
            toDate: '',
            fromTime: '',
            toTime: '',
            status: true,
        });
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    const formatTime = (timeString) => {
        if (!timeString) return 'N/A';
        // If time is in HH:MM format, format it nicely
        if (timeString.includes(':')) {
            const [hours, minutes] = timeString.split(':');
            const hour12 = hours % 12 || 12;
            const ampm = hours >= 12 ? 'PM' : 'AM';
            return `${hour12}:${minutes} ${ampm}`;
        }
        return timeString;
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const editEvent = (eventItem) => {
        const obj = JSON.parse(JSON.stringify(eventItem));
        obj.fromDate = formatDateForInput(eventItem.fromDate);
        obj.toDate = formatDateForInput(eventItem.toDate);
        setEvent(obj);
        handleOpen();
    };

    const deleteEvent = (eventDelete) => {
        if (window.confirm('Are you sure you want to delete this event?')) {
            if (eventDelete) {
                EventService.deleteEvent(eventDelete).then((res) => {
                    getEventList();
                    alert("Event Deleted Successfully.");
                }).catch((err) => {
                    alert("Error deleting event.");
                });
            }
        }
    };

    const formik = useFormik({
        initialValues: event,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.profileRegistrationId = userDetails.profileId;
            
            // Convert date strings to Date objects
            if (values.fromDate) {
                values.fromDate = new Date(values.fromDate);
            }
            if (values.toDate) {
                values.toDate = new Date(values.toDate);
            }

            if (event._id) {
                EventService.updateEvent(values).then((res) => {
                    handleClose();
                    getEventList();
                    resetForm();
                    alert("Event Updated Successfully.");
                }).catch((err) => {
                    alert(err.response?.data?.message || "Error updating event.");
                });
            } else {
                EventService.createEvent(values).then((res) => {
                    getEventList();
                    resetForm();
                    handleClose();
                    alert("Event Added Successfully.");
                }).catch((err) => {
                    alert(err.response?.data?.message || "Error adding event.");
                });
            }
        },
    });

    return (
        <>
            <PageTitle title="Events Details" button={<Button
                variant="contained" onClick={handleOpen}
                size="medium"
                color="secondary" style={{ backgroundColor: '#ff6b81' }}> Add Event Details
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <Table className="mb-0">
                            <TableHead>
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {eventList.slice(pg * rpg, pg * rpg + rpg).map((eventItem) => (
                                    <TableRow key={eventItem._id}>
                                       
                                        <TableCell className="pl-3 fw-normal">{eventItem.eventName}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatDate(eventItem.fromDate)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatDate(eventItem.toDate)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatTime(eventItem.fromTime)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatTime(eventItem.toTime)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {eventItem.status ? 'Active' : 'Inactive'}
                                        </TableCell>
                                        <TableCell>
                                            <EditIcon style={{ cursor: 'pointer' }} onClick={() => editEvent(eventItem)} />
                                        </TableCell>
                                        <TableCell>
                                            <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteEvent(eventItem)} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            count={eventList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                <DialogTitle>{event._id ? 'Edit Event' : 'Add Event Details'}</DialogTitle>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2}>
                            
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="eventName"
                                    name="eventName"
                                    label="Event Name"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.eventName}
                                    error={formik.touched.eventName && Boolean(formik.errors.eventName)}
                                    helperText={formik.touched.eventName && formik.errors.eventName}
                                />
                            </Grid>
                            
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined" margin="dense">
                                    <InputLabel id="status-select-label">Status</InputLabel>
                                    <Select
                                        labelId="status-select-label"
                                        id="status"
                                        name="status"
                                        value={formik.values.status ? 'true' : 'false'}
                                        onChange={(e) => formik.setFieldValue('status', e.target.value === 'true')}
                                        label="Status"
                                    >
                                        <MenuItem value="true">Active</MenuItem>
                                        <MenuItem value="false">Inactive</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="fromDate"
                                    name="fromDate"
                                    label="From Date"
                                    type="date"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.fromDate}
                                    error={formik.touched.fromDate && Boolean(formik.errors.fromDate)}
                                    helperText={formik.touched.fromDate && formik.errors.fromDate}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="toDate"
                                    name="toDate"
                                    label="To Date"
                                    type="date"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.toDate}
                                    error={formik.touched.toDate && Boolean(formik.errors.toDate)}
                                    helperText={formik.touched.toDate && formik.errors.toDate}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="fromTime"
                                    name="fromTime"
                                    label="From Time"
                                    type="time"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.fromTime}
                                    error={formik.touched.fromTime && Boolean(formik.errors.fromTime)}
                                    helperText={formik.touched.fromTime && formik.errors.fromTime}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="toTime"
                                    name="toTime"
                                    label="To Time"
                                    type="time"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.toTime}
                                    error={formik.touched.toTime && Boolean(formik.errors.toTime)}
                                    helperText={formik.touched.toTime && formik.errors.toTime}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="description"
                                    name="description"
                                    label="Description"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    multiline
                                    rows={4}
                                    onChange={formik.handleChange}
                                    value={formik.values.description}
                                    error={formik.touched.description && Boolean(formik.errors.description)}
                                    helperText={formik.touched.description && formik.errors.description}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" color="primary" variant="contained">
                            {event._id ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}

